var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoCommentinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.84 32.83"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 6.25H5.21C0 6.25 0 11.46 0 11.46V24s0 5.23 5.21 5.23h1.07l3.72 3.6 3.59-3.64H26c5.21 0 5.21-5.23 5.21-5.23v-12.5s0-5.21-5.21-5.21zM40.63 0H19.79c-5.2 0-5.2 5.2-5.2 5.2h2.08a3.06 3.06 0 013.12-3.13h20.84a3.07 3.07 0 013.13 3.13v12.5a3.07 3.07 0 01-3.13 3.13h-2.82L35.46 24l-2.4-3.14h-.79v2.1l3.19 3.64 3.1-3.64h2.07c5.21 0 5.21-5.23 5.21-5.23V5.21S45.84 0 40.63 0zM26 8.33H5.21a3.07 3.07 0 00-3.13 3.13V24a3.07 3.07 0 003.13 3.15H6.8l3.12 3.2 3.32-3.2H26A3.08 3.08 0 0029.17 24V11.46A3.07 3.07 0 0026 8.33z",
    fill: "#fdc800",
    fillRule: "evenodd",
    "data-name": "Capa 1"
  }))));
}

export default SvgCoCommentinline;